import React from 'react'
import Link from 'gatsby-link'

import arrowup from './arrowup.svg'

class ScrollBack extends React.Component {

  constructor(props, context){
    super(props, context);
    this.state = {visible: false};
    this.handleScroll = this.handleScroll.bind(this);
}

  componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {

      if (window.scrollY >= this.props.top){
      this.setState({ visible: true });
      console.log("past top");
    } else {
      this.setState({ visible: false });
    }

  }

  render() {
    return (
      <div className={(this.state.visible == true) ? "scrollback-bar active": "scrollback-bar"}>
      <a href="#" style={{
        maxWidth: "300px",
        margin: "0px auto",
        display: "block"
        }}><img src={arrowup}/></a>
      </div>
    )
  }
}

export default ScrollBack



// WEBPACK FOOTER //
// ./src/components/scrollback.js